import SwitchCheckedHHMTIcon from 'assets/icons/switch-checked-hhmt-icon.svg';
import SwitchCheckedRemoxIcon from 'assets/icons/switch-checked-remox-icon.svg';
import SwitchboxHHMTIcon from 'assets/icons/switchbox-hhmt-icon.svg';
import SwitchboxRemoxIcon from 'assets/icons/switchbox-remox-icon.svg';
import useTheme from 'hooks/useTheme';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputSwitch = ({ isChecked }) => {
  const { isHHMTTheme } = useTheme();

  const handleOnChange = () => {};

  return (
    <FormGroupStyled>
      <FormSwitch
        type="switch"
        checked={isChecked}
        onClick={handleOnChange}
        $checkboxSrc={isHHMTTheme ? SwitchboxHHMTIcon : SwitchboxRemoxIcon}
        $checkedSrc={
          isHHMTTheme ? SwitchCheckedHHMTIcon : SwitchCheckedRemoxIcon
        }
        readOnly
      />
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 0px;
  position: relative;
  height: 32px;
`;

const FormSwitch = styled(Form.Check)`
  margin: 0;
  margin-right: 0px;

  label {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    color: var(--ds-c-grey-dark);
    margin-left: 0px;
    cursor: pointer !important;
    user-select: none;

    @media screen and (min-width: 1200px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  input:checked[type='checkbox'] {
    background-image: ${(props) => `url(${props.$checkedSrc}) !important`};
    background-position: center !important;
  }

  input {
    border: none;
    border-radius: 2px;
    background-image: ${(props) => `url(${props.$checkboxSrc}) !important`};
    background-position: center !important;
    width: 40px !important;
    height: 24px !important;
    cursor: pointer !important;

    &:focus,
    &:active,
    &:checked {
      background-color: transparent;
      border: none;
      border-radius: 2px;
      box-shadow: none !important;
      filter: none !important;
    }
  }
`;

export default FormInputSwitch;
